"use client";

import { useEffect, useState } from "react";

export const useBookmark = (itemId: string) => {
	const [isBookmarked, setIsBookmarked] = useState(false);

	useEffect(() => {
		const bookmarks = JSON.parse(
			localStorage.getItem("blog_bookmarks") || "[]",
		);
		setIsBookmarked(bookmarks.includes(itemId));
	}, [itemId]);

	const toggleBookmark = () => {
		const bookmarks: string[] = JSON.parse(
			localStorage.getItem("blog_bookmarks") || "[]",
		);
		let updatedBookmarks: string[];

		if (bookmarks.includes(itemId)) {
			updatedBookmarks = bookmarks.filter((id: string) => id !== itemId);
			setIsBookmarked(false);
		} else {
			updatedBookmarks = [...bookmarks, itemId];
			setIsBookmarked(true);
		}

		localStorage.setItem("blog_bookmarks", JSON.stringify(updatedBookmarks));
	};

	return { isBookmarked, toggleBookmark };
};
